import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#2535AA',
        secondary: '#f2f2f2',
        accent: '#7DC6E6',
        error: '#fe7d99',
        info: '#2535AA',
        success: '#01c8a9',
        warning: '#fa9b3c'
      }
    }
  },
  colors: {
    shades: {
      black: '#041E49'
    }
  },
  icons: {
    iconfont: 'md'
  }
})
